import React from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutButton = ({ icon: Icon, collapsed }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };

  const style = {
    backgroundColor: 'transparent',
    color: '#fff',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  };

  if (!collapsed) {
    style.backgroundColor = 'var(--color-secondary)';
  }


  return (
    <button
      onClick={handleLogout}
      title="Sair"
      style={style}
    >
      {Icon && <Icon size={20} />}
      {!collapsed && 'Sair'}
    </button>
  );
};

export default LogoutButton;
